<template>
    <div class="multi-event-info">
        <div class="multi-event-info__title">Multiple Events</div>
        <div class="multi-event-info__main-wrapper">
            <div v-for="item in event" :key="item.id" class="multi-event-info__wrapper">
                <span
                    class="multi-event-info__level"
                    :class="{
                    'multi-event-info__level--red': item.eventClassification === 4,
                    'multi-event-info__level--yellow': item.eventClassification === 3,
                    'multi-event-info__level--green': item.eventClassification === 2
                }"
                    @click="showEvent(item)"
                >
                    <div>
                        <icon icon="warning" class="multi-event-info__icon"></icon>
                        {{ eventName(item.eventTypes[0]) }}
                    </div>
                    <div class="multi-event-info__date">{{ formatDate(item.triggerOn) }}</div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/atoms/Icon'
import store from '../../store'
import moment from 'moment'

export default {
    name: 'MultiEventInfoBubble',
    components: {
        Icon
    },
    props: {
        event: {
            type: Array,
            required: true
        },
        eventTypes: {
            type: Array,
            required: true
        }
    },
    methods: {
        eventName (value) {
            const event = this.eventTypes.find((elem) => {
                return elem.id === value
            })

            return event.key || 'Unknown'
        },
        showEvent (item) {
            const payload = { eventId: item.id, hardwareId: item.hardwareId }
            store.commit('setEventId', payload)
        },
        formatDate (date) {
            return moment(date).format('hh:mm')
        }
    }
}
</script>

<style scoped lang="scss">
.multi-event-info {
    min-width: 260px;
    position: relative;

    &__title {
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        color: $light-gray-500;
        text-align: center;
        letter-spacing: 1px;
        padding: 5px 0;
        border-bottom: 1px solid $light-gray-500;
    }

    &__main-wrapper {
        height: 100px;
        overflow-y: auto;
        padding: 0 5px 5px;
    }

    &__wrapper {
        margin-top: 4px;
        display: flex;
    }

    &__level {
        font-size: 10px;
        letter-spacing: 1px;
        text-transform: uppercase;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 5px;
        border: 1px solid #E1E1E1;
        border-radius: 4px;

        svg {
            fill: $white !important;
        }

        &--red {
            color: $danger;
            cursor: pointer;
            transition: box-shadow 0.3s;

            &:hover {
                box-shadow: 0 3px 6px #00000029;
            }

            svg {
                background-color: $danger;
                border-radius: 50%;
            }
        }

        &--yellow {
            color: #FDBF5E;
            cursor: pointer;
            transition: box-shadow 0.3s;

            &:hover {
                box-shadow: 0 3px 6px #00000029;
            }

            svg {
                background-color: #FDBF5E;
                border-radius: 50%;
            }
        }

        &--green {
            color: #09B66D;
            cursor: pointer;
            transition: box-shadow 0.3s;

            &:hover {
                box-shadow: 0 3px 6px #00000029;
            }

            svg {
                background-color: #09B66D;
                border-radius: 50%;
            }
        }
    }

    &__icon {
        margin-left: 6px;
        margin-top: -4px;
        width: 12px;
        height: 12px;
    }

    &__date {
        color: $light-gray-500;
    }

    &__number {
        position: absolute;
        left: 47%;
        bottom: -20px;
    }
}

</style>
